import { differenceInYears } from 'date-fns'
import { isEmployeeContractReady } from '@vivaldis/common'
import { EmployeeQuery_employee } from '../queries/__generated__/EmployeeQuery'

export function isEmployeeReady(employee?: EmployeeQuery_employee) {
  if (!employee || !employee.profile || !employee.workProfile) return false
  if (!isEmployeeContractReady(employee)) return false

  const {
    firstName,
    intentAgreementUrl,
    lastName,
    mobile,
    isStudent,
    profile: {
      birthdate,
      city,
      street,
      streetNumber,
      zip,
      country,
      countryOfBirth,
      nationalityCountry,
      placeOfBirth
    },
    studentAgreementUrl,
    workProfile: { isRetired, retiredOn }
  } = employee

  // intent agreement is required for all employees.
  // student agreement is only required for students
  const acceptedAgreement = isStudent
    ? intentAgreementUrl && studentAgreementUrl
    : intentAgreementUrl

  const EXPECTED_RETIRED_AGE = 60
  // when employee is 60 years or older, isRetired field must be set. (note: when isRetired is true, retiredOn must be set)
  const areRetirementFieldsAreMissing = !!(
    birthdate &&
    differenceInYears(new Date(), new Date(birthdate)) >=
      EXPECTED_RETIRED_AGE &&
    (isRetired === null || (isRetired === true && retiredOn === null))
  )

  return !!(
    mobile &&
    //
    firstName &&
    lastName &&
    //
    placeOfBirth &&
    countryOfBirth &&
    nationalityCountry &&
    //
    city &&
    street &&
    streetNumber &&
    zip &&
    country &&
    //
    acceptedAgreement &&
    //
    !areRetirementFieldsAreMissing
  )
}
